import React, { useState } from "react";
import T from "prop-types";
import styled, { css } from "styled-components/macro";
import TextInput from "commons/components/TextInput";
import Icon from "commons/components/Icon";
import Flexbox from "commons/components/Flexbox";
import { BREAKPOINTS } from "commons/util/breakpoints";
import { TAG_COLOR_LIST } from "commons/util/constants";
import { useTranslation } from "react-i18next";
import Button from "commons/components/Button";

const Box = styled(Flexbox)`
  max-width: 348px;
  cursor: default;

  @media (max-width: ${BREAKPOINTS.small}) {
    width: calc(100vw - 112px);
  }
`;

const ColorTile = styled.div`
  width: 20px;
  height: 20px;
  border-radius: var(--border-radius-1);
  background-color: ${({ color }) => color && `var(--${color}-100)`};
  cursor: pointer;

  ${({ isActive }) => isActive && css``}
`;

function TagCreatePopoverContent({ className, color: initColor, addTag, closePopover }) {
  const { t } = useTranslation();
  const [label, setLabel] = useState("");
  const [color, setColor] = useState(initColor || "grey");

  function handleAdd() {
    addTag({ label, color });
    closePopover();
  }

  return (
    <Box className={className} gap={24} flexDirection="column" padding={24}>
      <TextInput
        label={t("Tags.TagName")}
        value={label}
        onChange={setLabel}
        onConfirm={closePopover}
        maxLength={32}
        autoFocus
      />
      <Flexbox gap={8} flexWrap="wrap">
        {TAG_COLOR_LIST.map(presetColor => (
          <ColorTile
            key={presetColor}
            color={presetColor}
            isActive={presetColor === color}
            onClick={() => setColor(presetColor)}
          >
            {presetColor === color && <Icon name="check" color="neutral-200" size={20} />}
          </ColorTile>
        ))}
      </Flexbox>
      <Flexbox gap={8} justifyContent="flex-end">
        <Button variant="tertiary" onClick={closePopover}>
          {t("Common.Cancel")}
        </Button>
        <Button onClick={handleAdd}>{t("Tags.AddTag")}</Button>
      </Flexbox>
    </Box>
  );
}

TagCreatePopoverContent.propTypes = {
  className: T.string,
  color: T.string,
  addTag: T.func,
  closePopover: T.func,
};

export default TagCreatePopoverContent;
